import React from 'react';
import styled from 'styled-components';
import { Link, Typography } from '@drone-js/core';

export const TypographyWithHover = styled(Typography)`
    &:hover {
        text-decoration: underline;
        text-underline-offset: 4px;
    }
`;

export type ActivityTextLinkProps = React.ComponentProps<typeof Link> & { typography: React.ComponentProps<typeof Typography>; disableLinkFocus?: boolean };

/**
 * This component is created because the TextLink component from Drone does now allow overriding font-color and weight.
 */
export const ActivityTextLink: React.FC<React.PropsWithChildren<ActivityTextLinkProps>> = (props) => {
    const { children, typography, href, disableLinkFocus, ...rest } = props;
    return (
        <Link href={href} tabIndex={disableLinkFocus ? -1 : 0} {...rest}>
            <TypographyWithHover tag="span" {...typography}>
                {children}
            </TypographyWithHover>
        </Link>
    );
};
ActivityTextLink.displayName = 'CustomLink';
